// extracted by mini-css-extract-plugin
export default {"buttonGroup":"CopilotAgentModeButton-module__buttonGroup__XV9lsw2"};